
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import router from './router/router'
import store from './store'
import weixin from 'weixin-js-sdk'
import '@/icons' // icon
// import { getOpenId } from './api/wechat/index'
import clipboard from './directive/clipboard'
Vue.config.productionTip = false
Vue.use(VueRouter)

import 'element-ui/lib/theme-chalk/index.css'
import {
  Button,
  Dialog,
  Input,
  Card,
  Tabs,
  TabPane,
  Image,
  MessageBox,
  Message,
  Collapse,
  CollapseItem,
  Tooltip,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxButton,
  CheckboxGroup
} from 'element-ui'

Vue.use(Button)
Vue.use(TabPane)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(Input)
Vue.use(Card)
Vue.use(Image)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Tooltip)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message
import DrawerLayout from 'vue-drawer-layout'
import VueCookies from 'vue-cookies'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
// import Vconsole from 'vconsole'
// new Vconsole()

Vue.use(preview)

Vue.use(DrawerLayout)
// 联想登录页面逻辑需要使用cookie
Vue.use(VueCookies)
// 创建一个路由器实例
/* eslint-disable no-new */
Vue.directive('focus', {
  inserted: function(el) {
    el.focus()
  }
})
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})

window.sdkBaseApi = 'https://imccdev.lenovo.com.cn/'

clipboard.install(Vue)

function checkBrowser() {
  const ua = navigator.userAgent.toLowerCase()
  const isWeixin = ua.indexOf('micromessenger') !== -1
  VueCookies.set('isWechat', isWeixin)
  // if (isWeixin) {
  //   if (!VueCookies.get('lcube_openid')) {
  //     getOpenId()
  //   }
  //   setTimeout(() => {
  //     localStorage.removeItem('HREF')
  //   }, 10)
  //   return true
  // } else {
  //   console.log('不是微信浏览器')
  //   VueCookies.set('isWechat', false)
  //   setTimeout(() => {
  //     localStorage.removeItem('HREF')
  //   }, 10)
  //   return false
  // }
  console.log('不是微信浏览器')
  VueCookies.set('isWechat', false)
  setTimeout(() => {
    localStorage.removeItem('HREF')
  }, 10)
  return false
}

if (checkBrowser()) {
  const wx = window.nov
  window.weixin = weixin
  wx.initWechatJSSDK({
    jsApiList: ['hideMenuItems']
  }).then(wx => {
    wx.hideMenuItems({
      menuList: ['menuItem:copyUrl'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    })
  }).catch(err => {
    console.log(err)
  })
} else {
  console.log('not wechat')
}
window.temporaryRepair = function() {
  let currentPosition
  const speed = 1
  const timer = setInterval(function() {
    currentPosition = document.documentElement.scrollTop || document.body.scrollTop
    currentPosition -= speed
    window.scrollTo(0, currentPosition)
    currentPosition += speed
    window.scrollTo(0, currentPosition)
    clearInterval(timer)
  }, 1)
}

// window.lenovoApi('robotService', {
//   name: 'yefan',
//   title: '智能客服',
//   robotUrl: 'https://imccdev.lenovo.com.cn/webchat#/webchat?channel=webchat&tab=chatRobot&type=1&isLogin=2',
//   icon: 'http://js.90sjimg.com/images/commercial.png' // 只支持透明背景PNG格式, 非必传, 只能是链接
// })
// window.lenovoApi('peopleService', {
//   name: 'yefan',
//   title: '人工客服', // 需要展示的icon文字
//   queueCode: 'webchat_5cf729a670368', // 指定判断时间的队列
//   icon: 'http://js.90sjimg.com/images/commercial.png', // 只支持透明背景PNG格式, 非必传, 只能是链接
//   config: {}, // 登录模式下给定的用户信息,无数据或者没传时为游客模式,
//   chatQueueCode: '', // 人工客服进入的队列，为空或未传时进入点选页面
//   robotUrl: 'https://imccdev.lenovo.com.cn/webchat#/webchat?channel=webchat&tab=chatRobot&type=1&isLogin=2'
// })
// // window.lenovoApi('staticShow', {
// //   name: 'yefan',
// //   title: '电话咨询', // 需要展示的icon文字
// //   text: '11111111111111' // 需要展示的额外文字
// // })
// window.lenovoApi('staticShow', {
//   name: 'yefan',
//   title: '电话咨询', // 需要展示的icon文字
//   text: '电话咨询：4000-800-9838', // 需要展示的额外文字
//   icon: 'http://js.90sjimg.com/images/commercial.png' // 只支持透明背景PNG格式, 非必传, 只能是链接
// })
// window.lenovoApi('timingFunc', {
//   name: 'yefan',
//   title: '11121',
//   delay: 1000, // 弹窗延迟时间
//   time: 24, // localstorage有效时间,单位为小时
//   url: 'https://imccdev.lenovo.com.cn/#/'
// })

window.LenovoIdSyncLoginState = function(lenovid_wust) {
  store.dispatch('SetLoginSt', lenovid_wust)
}



// WEBPACK FOOTER //
// ./src/main.js